import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components/macro';
import { Button, Title } from '@cognite/cogs.js';
import { Input, Modal, InputRef } from 'antd';

export const EditNameDialog = ({
  itemType,
  itemName,
  onClose,
  onRename,
}: {
  itemType: string;
  itemName: string;
  onClose: () => void;
  onRename: (newName: string) => void;
}) => {
  const [newItemName, setNewItemName] = useState(itemName);
  const [loading, setLoading] = useState(false);

  const renameItem = async () => {
    if (!newItemName.trim()) return;

    setLoading(true);
    try {
      await onRename(newItemName);
    } finally {
      onClose();
    }
  };

  const inputRef = useRef<InputRef>(null);
  useEffect(() => {
    inputRef?.current?.focus();
    setNewItemName(itemName);
  }, []);

  const onChangeItemName = (e: React.FormEvent<HTMLInputElement>) => {
    setNewItemName(e.currentTarget.value);
  };

  const onEnterPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      renameItem();
    }
  };

  return (
    <Modal visible footer={null} onCancel={onClose}>
      <Title level={4} style={{ marginBottom: '1.5rem' }}>
        {`Edit ${itemType} name`}
      </Title>
      <StyledLabel>{`${itemType} name`}</StyledLabel>
      <div>
        <Input
          ref={inputRef}
          placeholder={`${itemType} name`}
          value={newItemName}
          onChange={onChangeItemName}
          onKeyDown={onEnterPress}
        />
      </div>
      <StyledButtons>
        <Button type="ghost" onClick={onClose} style={{ marginRight: '1rem' }}>
          Cancel
        </Button>
        <Button
          type="primary"
          loading={loading}
          onClick={(e) => {
            e.stopPropagation();
            renameItem();
          }}
          disabled={newItemName.trim().length === 0}
        >
          Save
        </Button>
      </StyledButtons>
    </Modal>
  );
};

const StyledButtons = styled.div`
  padding: 2rem 0 0 0;
  text-align: right;
`;

const StyledLabel = styled.p`
  font-family: Inter;
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  margin: 0.5rem 0.2rem;
`;
